import React, { Component } from 'react';
import RatesPage from './rates-html';
class Rates extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <RatesPage />
            </div>
        )
    }
}
export default Rates;